import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import {
  etClientsBg1,
} from "@/assets/img/imageAssets.js"

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.8, ease: "easeOut" },
  }),
};

const EtEternityClients = () => {
  // First Created - 08 Oct 2025
  // Author - Atul Pandey
  // Purpose - Bridge narrative inviting users to the Clients page

  return (
    <section
      id="clients"
      className="relative py-32 bg-gradient-to-b from-black via-orange-700/80 to-black text-white overflow-hidden"
    >
      {/* Subtle background texture */}
      {/* <div className="absolute inset-0 opacity-[0.05] bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] mix-blend-overlay" /> */}

      <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-800 to-black animate-[pulse_12s_ease-in-out_infinite]" />

      {/* Supporting abstract image */}
      <div
        className="absolute inset-0 opacity-[0.7] bg-cover bg-center mix-blend-soft-light animate-[pulse_12s_ease-in-out_infinite]"
        style={{ backgroundImage: `url(${etClientsBg1})` }}
      ></div>

      {/* Animated orange pulse overlay */}
      {/* <div className="absolute inset-0 bg-gradient-to-br from-orange-700/30 via-orange-600/20 to-transparent mix-blend-soft-light animate-[pulse_12s_ease-in-out_infinite]" /> */}


      <motion.div
        className="absolute w-32 h-32 rounded-full bg-orange-500/80 blur-3xl top-1/3 left-1/4"
        animate={{ y: [0, -20, 0], opacity: [0.3, 0.6, 0.3] }}
        transition={{ repeat: Infinity, duration: 10, ease: "easeInOut" }}
      />


      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
        {/* Headline */}
        <motion.h2
          className="text-3xl md:text-5xl font-bold text-white mb-10 leading-relaxed"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          custom={0}
        >
          Built for <span className="text-orange-500 animate-pulse">Leaders</span> Who Turn Vision into Value
        </motion.h2>

        {/* Narrative lines */}
        <motion.p
          className="text-gray-200 font-extralight text-lg md:text-2xl leading-relaxed mb-12"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          custom={1}
        >
          From <span className="text-white font-bold ">founders reimagining</span> their tech-led firms <br className="hidden md:block" />
          to <span className="text-white font-bold ">partners backing</span> them for accelerated growth — <br className="hidden md:block" />
          Eternity brings <span className="text-white font-bold ">purpose, rhythm, and performance</span> together.
        </motion.p>

        {/* CTA */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          custom={2}
        >
          <a
            href="/clients"
            className="inline-flex items-center gap-2 px-8 py-4 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-lg shadow-lg transition"
          >
            Explore How We Help Clients Grow
            <ArrowRightIcon className="h-5 w-5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default EtEternityClients;